import api from '@/api/client'

/**
 * Preferences service
 */

/**
 * Get current user's preferences.
 */
export const getMyPreferences = async () => {
  const res = await api.get('user-preferences/me/')
  return res.data
}

/**
 * Update current user's preferences.
 * @param {Record<string, any>} updates
 */
export const updatePreferences = async (updates) => {
  const res = await api.post('user-preferences/update_preferences/', updates)
  return res.data
}
